import React, { useEffect } from "react";
import { useNavigate } from "react-router";

const Dashboard = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/tools");
  });
  return <div></div>;
};

export default Dashboard;
